import React from 'react';
import { CrossIcon, DownloadIcon } from 'common/designSystem/iconComponents';
import { saveFile } from 'common/utils/saveFile';

export const PreviewImage = ({
  id, src, name, isPreview, onClickModifier, fileKey, fileUrl, isDownload = false, enablePreview = false, onPreview,
}: {
    id?: number,
    src: string,
    name: string,
    isPreview: boolean,
    fileKey?: string,
    fileUrl?: string,
    isDownload?: boolean,
    enablePreview?: boolean,
    onClickModifier?: (docFileId?: number, fileName?: string) => void,
    onPreview?: () => void
   }) => {
  const downloadFile = (url: string, fileName: string) => {
    saveFile(url, fileName);
  };

  const handleClick = () => {
    if (enablePreview && onPreview) {
      onPreview();
    }
  };

  return (
    <button
      type="button"
      className="preview flex flex-col text-center relative"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: 140,
      }}
      onClick={handleClick}
    >
      { isPreview && (
        <div
          style={{
            position: 'absolute', top: 8, right: 8, zIndex: 10,
          }}
        >
          <CrossIcon
            className="h-[24px] w-[24px] text-white rounded-[50%]"
            onClick={(e) => {
              e.stopPropagation();
              if (onClickModifier) onClickModifier(id, fileKey);
            }}
          />
        </div>
      )}
      { isDownload && (
        <div
          style={{
            position: 'absolute', top: 8, left: 8, zIndex: 10,
          }}
        >
          <DownloadIcon
            className="h-[32px] w-[32px] text-white rounded-[50%]"
            style={{ background: '#000' }}
            onClick={(e) => {
              e.stopPropagation();
              downloadFile(fileUrl ? fileUrl : src, name);
            }}
          />
        </div>
      )}
      <img
        src={src}
        style={{ objectFit: 'cover' }}
        className="h-[100px] w-[100px] rounded-lg"
        alt={name}
        data-cy="file-preview"
      />
      <span
        className="text-xs mt-1.5 text-gray-700 truncate"
        style={{ maxWidth: 100 }}
      >
        {name}
      </span>
    </button>
  );
};
